import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { ReportService } from "../../services/report-service";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { DateLocaleService } from "../../services/date-locale-service";
import { Dictionary } from "lodash";
import { StorageService } from "../../services/storage-service";
import { AccountService } from "../../services/account-service";

export class SSRSReportController {

    static $inject = ["$scope", "$location", "reportService", "entityService", "notifyService", "dateLocaleService", "storage", "$window", "accountService"];

    reports: Models.IReport[];
    selectedReport: Models.IReport;
    reportParameters: Models.IReportParameter[];
    reportParametersByCharType: Dictionary<Models.IReportParameter[]>;
    searchRecordsReportParametersByCharType: Dictionary<Models.IReportParameter[]>;
    currentPage: Dictionary<number>;
    pageCount: Dictionary<number>;
    numFound: Dictionary<number>;
    rowCount: number;
    reportGroups: Models.IReportGroup[];
    openedGroup: Models.IReportGroup;
    parametersLoaded: boolean;
    loadingParameters: boolean;
    hasParameters: boolean;
    executeOffline: boolean;
    showJobProgress: boolean;
    jobId: string;
    jobTitle: string;
    progressStatus: string;
    paramRe: RegExp;
    showRequiredOnly: boolean;
    modalOpen: boolean;
    selectedParameter: Models.IReportParameter;
    selectedSavedReport: Models.ISavedSSRSReport;
    parametersValid: boolean;
    totalSavedReports: number;

    constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private reportService: ReportService, private entityService: EntityService,
        private notifyService: NotifyService, private dateLocaleService: DateLocaleService, private storage: StorageService, private $window: ng.IWindowService,
        private accountService: AccountService) {
        this.reports = [];
        this.reportParameters = [];
        this.reportParametersByCharType = {};
        this.searchRecordsReportParametersByCharType = {};
        this.currentPage = {};
        this.numFound = {};
        this.pageCount = {};
        this.rowCount = 10;
        this.reportGroups = [];
        this.parametersLoaded = false;
        this.loadingParameters = false;
        this.hasParameters = false;
        this.executeOffline = false;
        this.showJobProgress = false;
        this.jobId = null;
        this.jobTitle = null;
        this.progressStatus = null;
        this.paramRe = /p_c(\d+)([txs])(\d+|\*)?([rsv])?(__.*)?/;
        this.showRequiredOnly = false;
        this.selectedParameter = null;
        this.modalOpen = true;
        this.parametersValid = false;
        this.totalSavedReports = 0;

        $scope.$watch(() => this.selectedReport, (newValue, oldValue) => {
            if (newValue && newValue != oldValue) {
                this.selectedSavedReport = null;
                this.ResetReportParameters();
            }
        });

        $scope.$watch(() => this.selectedSavedReport, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.ApplySavedReport();
            }
        });

        $scope.$watch(() => this.selectedParameter, (newValue, oldValue) => {
            if (newValue && newValue != oldValue) {
                newValue.parameterValue = newValue.selectedParameterValue;

                if (this.IsRecordParam(newValue)) {
                    //set up pager values
                    this.numFound[newValue.parameterName] = newValue.selectedRecIdTitlePairs.length;
                    this.pageCount[newValue.parameterName] = newValue.selectedRecIdTitlePairs.length / this.rowCount;
                }

                if (newValue.parameterName.includes('freetext') || newValue.parameterType == 'Float' || newValue.parameterType == 'Integer') {
                    newValue.selectedParameterDisplay = newValue.parameterValue;
                }
                if (newValue.parameterType == 'DateTime') {
                    newValue.parameterValue = this.DelocalizeDate(newValue.parameterValue);// store the underlying date in US format
                    newValue.selectedParameterDisplay = newValue.selectedParameterValue;
                }
                this.parametersValid = _.all(this.reportParameters, (p) => p.allowBlank || p.parameterValue != '');
            }
        }, true);

        this.Init();
    }

    LocalizeDate(input: string) {
        var moment = this.dateLocaleService.parseStorageMoment(input);
        if (moment.isValid()) {
            var localMoment = this.dateLocaleService.localizeMoment(moment);
            return localMoment.format("L");
        } else {
            return "";
        }
    }

    DelocalizeDate(input: string) {
        var moment = this.dateLocaleService.parseMoment(input);
        if (moment.isValid()) {
            var storageMoment = this.dateLocaleService.delocalizeMoment(moment);
            return storageMoment.format("L");
        } else {
            return "";
        }
    }

    keyPressHandeler(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    Init() {
        this.GetReportList();
    }

    ToggleGroup(group: Models.IReportGroup) {
        if (this.openedGroup == group) {
            this.openedGroup = null;
        } else {
            this.openedGroup = group;
        }
    }

    ClearAll() {

        if (this.$window.confirm("Are you sure you want to delete all saved reports?")) {

            for (var i = 0; i < this.reportParameters.length; i++) {
                var param = this.reportParameters[i];
                param.parameterValue = null;
            }
            this.$scope.$broadcast('ssrsReportParamsClear');

            this.notifyService.startProgress();
            let deleteReportForKey: Models.ISaveReportCriteria = {
                nameSpace: Consts.ReportNameSpace.SSRSReports,
                reportName: this.selectedReport.reportName,
                savedReports: [],
                isGlobal: Consts.IsGlobal.No,
                savedReportsJson: ""
            };

            this.reportService.deleteReportCriteria(deleteReportForKey)
                .then(() => {
                    this.notifyService.endProgress();
                    this.ResetReportParameters();
                });
        }
    }

    GetReportList() {
        this.notifyService.startProgress();
        this.reportService.getReportList()
            .then((results) => {
                this.reports = results;
                var g = {};
                for (var i = 0; i < this.reports.length; i++) {
                    var report = this.reports[i];
                    var path = report.group || "Default";
                    report.group = path;
                    if (!g[path]) {
                        g[path] = true;

                        this.reportGroups.push({
                            groupName: path
                        });
                    }

                    for (var j = 0; j < this.reportGroups.length; j++) {
                        var group = this.reportGroups[j];
                        group.reports = group.reports || [];
                        if (group.groupName == path) {
                            group.reports.push(report);
                        }
                    }
                }

                if (this.reportGroups.length > 0) {
                    this.openedGroup = this.reportGroups[0];
                }
            })
            .finally(() => {
                this.MoveSavedReportsFromLocalStorageToDB();
                this.notifyService.endProgress();
            });
    }

    ResetReportParameters() {
        this.reportParameters = [];
        this.parametersLoaded = false;
        this.loadingParameters = true;
        this.reportParametersByCharType = {}
        this.searchRecordsReportParametersByCharType = {};
        this.selectedParameter = null;
        this.parametersValid = true;
        this.hasParameters = false;

        if (this.selectedReport != undefined || this.selectedReport != null) {
            return this.reportService.getReportParameters(this.selectedReport.reportName)
                .then((results) => {
                    this.parametersLoaded = true;
                    this.reportParameters = results;
                    this.reportService.getReportParameterMapping().then((map) => {
                        this.reportParametersByCharType["All"] = this.reportParameters;
                        _.forEach(this.reportParameters, (p) => {
                            if (p.parameterName != "p_div_id") {
                                this.hasParameters = true;
                            }

                            if (p.parameterName == "p_url_id") {
                                this.accountService.getAppUrlId()
                                    .then((resp) => {
                                        p.selectedParameterValue = resp.data.toString();
                                        p.parameterValue = resp.data.toString();
                                    });
                            }

                            if (_.isUndefined(p.parameterPrompt) || p.parameterPrompt == '') {
                                return;
                            }
                            var match = this.paramRe.exec(p.parameterName);
                            var charTypeID = -1; // -1 to represent catch all for anything without a char type

                            if (match != null && match[1] != null) {
                                charTypeID = _.parseInt(match[1]);
                            }
                            else {
                                //couldn't find char type match, check for param to char type mapping file
                                _.forEach(map, (val, key) => {
                                    if (key.toLowerCase() == p.parameterName.toLowerCase()) {
                                        charTypeID = _.parseInt(val);
                                        return false; //found the one we wanted, break out of foreach
                                    }
                                });
                            }
                            var charTypeLabel = charTypeID > 0 ? Consts.PluralCharTypeNames.IDs[charTypeID] : "Misc";

                            if (match != null && match[4] != null && match[4] == "r") {
                                //this param is for searching records, handle special
                                if (_.any(this.searchRecordsReportParametersByCharType[p.parameterPrompt])) {
                                    this.searchRecordsReportParametersByCharType[p.parameterPrompt].push(p);
                                }
                                else {
                                    this.searchRecordsReportParametersByCharType[p.parameterPrompt] = [p];
                                    this.currentPage[p.parameterName] = 1;
                                }
                            }

                            if (_.any(this.reportParametersByCharType[charTypeLabel])) {
                                this.reportParametersByCharType[charTypeLabel].push(p);
                            }
                            else {
                                this.reportParametersByCharType[charTypeLabel] = [p];
                            }

                            if (p.parameterValue && p.parameterValue != '') {
                                //this parameter has a default value
                                p.selectedParameterValue = p.parameterValue;
                                if (p.parameterType == "DateTime") {
                                    p.selectedParameterValue = this.LocalizeDate(p.parameterValue);
                                }
                                this.ApplySelectedParameter(p, false);
                            }
                            if (!p.allowBlank && p.parameterValue == '') {
                                this.parametersValid = false; //found a required field not filled in
                            }
                        });
                    });
                })
                .finally(() => {
                    this.loadingParameters = false;
                });
        }
    }

    IsRecordParam(parameter: Models.IReportParameter) {
        var result = false;
        var match = this.paramRe.exec(parameter.parameterName);
        //get params that are specifically for record search
        if (match != null && match[4] != null && match[4] == "r") {
            result = true;
        }

        return result;
    }

    NonRecordParams(parameters: Models.IReportParameter[]) {
        //filter out the record search parameters we are handling in a special way
        var result = [];
        _.forEach(parameters, (p) => {
            var match = this.paramRe.exec(p.parameterName);
            if (match == null || match[4] == null || match[4] != "r") {
                result.push(p);
            }
        });
        return result;
    }

    ExecuteReportOffline(reportForm: ng.IFormController) {
        this.reportParameters.forEach(param => {
            if (reportForm[param.parameterName]) {
                param.parameterValue = reportForm[param.parameterName].$viewValue;
            }
        });

        this.reportService.executeReportOffline(this.selectedReport.reportName, this.reportParameters).then((result) => {
            this.showJobProgress = true;
            this.jobId = result.jobID;
            this.jobTitle = result.jobTitle;

        });
    }

    ClearAllForCharType(charType: string) {
        _.forEach(this.reportParametersByCharType[charType], (p) => {
            if (!this.IsRecordParam(p)) {
                this.ClearParam(p.parameterPrompt);
            }
        });
    }

    ClearParam(paramPrompt: string) {
        var param = _.find(this.reportParameters, (r) => r.parameterPrompt == paramPrompt);

        param.selectedParameterDisplay = "";
        param.selectedParameterValue = "";
        param.parameterValue = "";

        if (param == this.selectedParameter) {
            var tempParam = _.cloneDeep(this.selectedParameter);
            this.selectedParameter = null;
            this.selectedParameter = tempParam;
        }

        this.parametersValid = _.all(this.reportParameters, (p) => p.allowBlank || p.parameterValue != '');
    }

    GetSelectedRecords(parameter: Models.IReportParameter) {
        var match = this.paramRe.exec(parameter.parameterName);

        if (match != null && match[1] != null) {
            var request: Models.ISearchResultByRecordIDsRequest = {
                charTypeID: _.parseInt(match[1]),
                recordIDs: parameter.selectedParameterValue
            }
            this.entityService.getRecordDocumentsForRecordIDs(request).then((result) => {
                return result.documents;
            });
        }
    }

    RemoveTitleFromRecordParam(recordID: number, param: Models.IReportParameter) {
        var tempParam = _.cloneDeep(param.selectedRecIdTitlePairs);
        param.selectedRecIdTitlePairs = [];
        //remove the id/title pair from the params key value pairs, then rebuild the comma separated lists
        _.remove(tempParam, (kp) => kp.key == recordID);
        param.selectedParameterValue = _(tempParam)
            .map(doc => doc.key)
            .uniq()
            .value()
            .join(",");
        param.parameterValue = param.selectedParameterValue;
        param.selectedParameterDisplay = _(tempParam)
            .map(doc => doc.value)
            .uniq()
            .value()
            .join(", ");
        param.selectedRecIdTitlePairs = tempParam;
        this.selectedParameter = null;

    }

    ApplySelectedParameter(param: Models.IReportParameter, showMessage: boolean) {
        if (this.IsRecordParam(param)) {
            //set up pager values
            if (param.selectedRecIdTitlePairs != undefined) {
                this.numFound[param.parameterName] = param.selectedRecIdTitlePairs.length;
                this.pageCount[param.parameterName] = param.selectedRecIdTitlePairs.length / this.rowCount;
            }
        }

        if (param.parameterName.includes('freetext') || param.parameterType == 'Float' || param.parameterType == 'Integer') {
            param.parameterValue = param.selectedParameterValue;
            param.selectedParameterDisplay = param.parameterValue;
        }
        else if (param.parameterType == "DateTime") {
            param.parameterValue = this.DelocalizeDate(param.selectedParameterValue);
            param.selectedParameterDisplay = this.LocalizeDate(param.parameterValue);
        }
        else {
            param.parameterValue = param.selectedParameterValue;
        }
        if (showMessage) {
            this.notifyService.notifySuccess("Selected " + param.parameterPrompt + " applied to selected criteria.")
        }

    }

    SetSelectedParameter(param: Models.IReportParameter) {
        this.modalOpen = false;

        this.selectedParameter = param;
        if (this.selectedParameter.parameterValue && this.selectedParameter.parameterValue != '') {
            if (this.selectedParameter.parameterType == "DateTime") {
                this.selectedParameter.selectedParameterValue = this.LocalizeDate(this.selectedParameter.parameterValue);
            }
            else {
                this.selectedParameter.selectedParameterValue = this.selectedParameter.parameterValue;
            }
        }
        if (!this.selectedParameter.selectedRecIdTitlePairs) {
            this.selectedParameter.selectedRecIdTitlePairs = [];
        }
        if (this.IsRecordParam(param)) {
            this.modalOpen = true;
        }
    }

    HasSelectedValues(dictionary: Dictionary<Models.IReportParameter>, key: string) {
        var results = {}
        return _.any(dictionary[key], (p) => p.parameterValue && p.parameterValue != '' && p.parameterPrompt != '');
    }

    ApplySavedReport() {
        if (this.selectedSavedReport == null) {
            return;
        }
        else {
            this.parametersValid = true;
            this.ResetReportParameters().then(() => {
                this.reportParameters = this.selectedSavedReport.reportParameters;

                for (var i: number = 0; i < this.selectedSavedReport.reportParameters.length; ++i) {
                    var savedReportParam: Models.IReportParameter = this.selectedSavedReport.reportParameters[i];
                    var reportParam = _.find(this.reportParameters, f => f.parameterName === savedReportParam.parameterName);

                    var paramOuputToSet: string = this.selectedSavedReport.reportParameters[i].selectedParameterValue;
                    var paramDisplayToSet: string = this.selectedSavedReport.reportParameters[i].selectedParameterDisplay;
                    var paramValueToSet: string = this.selectedSavedReport.reportParameters[i].parameterValue;

                    if (reportParam != null) {

                        if (paramDisplayToSet !== reportParam.selectedParameterDisplay) {
                            reportParam.selectedParameterDisplay = paramDisplayToSet;
                        }

                        if (paramOuputToSet !== reportParam.selectedParameterValue) {
                            reportParam.selectedParameterValue = paramOuputToSet;
                        }

                        if ((reportParam.parameterType === "Float" || reportParam.parameterType === "Integer") && (paramValueToSet !== reportParam.parameterValue)) {
                            reportParam.parameterValue = paramValueToSet;
                        }
                        else if (reportParam.parameterType == "DateTime") {
                            reportParam.selectedParameterDisplay = this.LocalizeDate(reportParam.parameterValue);
                        }
                    }
                }

                _.forEach(this.reportParameters, (p) => {
                    if (p.parameterValue && p.parameterValue != '') {
                        if (p.parameterType == "DateTime") {
                            reportParam.selectedParameterDisplay = this.LocalizeDate(reportParam.parameterValue);
                        }
                        else {
                            p.selectedParameterValue = p.parameterValue;
                        }
                    }

                    if (this.IsRecordParam(p)) {
                        var match = this.paramRe.exec(p.parameterName);
                        var paramValueLength = 20;
                        if (!_.isEmpty(p.selectedParameterValue)) {
                            var splits = p.selectedParameterValue.split(",");
                            paramValueLength = splits.length;
                        }

                        var request: Models.ISearchResultByRecordIDsRequest = {
                            charTypeID: _.parseInt(match[1]),
                            recordIDs: p.selectedParameterValue,
                            rowCount: paramValueLength
                        }

                        p.selectedRecIdTitlePairs = [];
                        this.entityService.getRecordDocumentsForRecordIDs(request).then((result) => {
                            _.forEach(result.documents, (doc) => { p.selectedRecIdTitlePairs.push({ key: doc.recordID, value: doc.title }) });
                            if (p.selectedRecIdTitlePairs.length > 0) {
                                this.numFound[p.parameterName] = p.selectedRecIdTitlePairs.length;
                                this.pageCount[p.parameterName] = p.selectedRecIdTitlePairs.length / this.rowCount;
                            }
                        });
                    }

                    if (p.selectedParameterValue && p.selectedParameterValue != '') {
                        //this parameter has a default value
                        if (p.parameterType == "DateTime") {
                            p.parameterValue = this.DelocalizeDate(p.selectedParameterValue);
                        }
                        else {
                            p.parameterValue = p.selectedParameterValue;
                        }
                        this.ApplySelectedParameter(p, false);
                    }

                    if (!p.allowBlank && p.parameterValue == '') {
                        this.parametersValid = false;
                    }
                });
            }).finally(() => {
                var div = document.getElementById('primaryDiv');
                $(div).animate({ scrollTop: div.scrollHeight }, 500);
                this.notifyService.notifySuccess(this.selectedSavedReport.savedReportName + " applied.");
            });

        }
    }

    MoveSavedReportsFromLocalStorageToDB() {
        if (this.reports.length > 0) {
            var divID = this.reports[0].divID;

            this.reportService.getSavedReportsList(Consts.ReportNameSpace.SSRSReports, "", Consts.IsGlobal.No)
                .then((results) => {
                    let hasAnySavedReports: boolean = false;

                    if (results != null) {
                        if (results.savedReports.length > 0) {
                            hasAnySavedReports = true;
                        }
                    }

                    if (!hasAnySavedReports) {
                        var reportKeyStartWith = "div" + divID + "_savedSSRSReport_";
                        var allSavedReport: Models.ISaveReportCriteria[] = [];
                        var cleanKeys: string[] = [];

                        for (var i = 0; i <= localStorage.length - 1; i++) {
                            var key = localStorage.key(i);
                            if (key.includes(reportKeyStartWith)) {
                                console.log(key);
                                var savedReports: Models.ISavedSSRSReport[] = this.storage.get(key.trim()) || [];
                                if (savedReports.length > 0) {

                                    cleanKeys.push(key);
                                    var savedReportName = key.replace(reportKeyStartWith, "");

                                    let savedReportForKey: Models.ISaveReportCriteria = {
                                        nameSpace: Consts.ReportNameSpace.SSRSReports,
                                        reportName: savedReportName,
                                        savedReports: savedReports,
                                        savedReportsJson: "",
                                        isGlobal: Consts.IsGlobal.No
                                    };

                                    allSavedReport.push(savedReportForKey);
                                }
                            }
                        }

                        if (allSavedReport.length > 0) {
                            this.reportService.moveSavedReportsFromLocalStorageToDB(allSavedReport);
                        }
                    }
                });
        }
    }
}